import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiMinus, FiPlus, FiCreditCard } = FiIcons;

const CartDrawer = ({ isOpen, onClose, items, onUpdateQuantity, totalPrice }) => {
  const handleCheckout = () => {
    alert('Redirecting to secure checkout...');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="cart-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="cart-drawer"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
          >
            <div className="cart-header">
              <h2 className="cart-title">YOUR SILENCE</h2>
              <button className="cart-close" onClick={onClose}>
                <SafeIcon icon={FiX} />
              </button>
            </div>

            <div className="cart-content">
              {items.length === 0 ? (
                <div className="cart-empty">
                  <p>Your cart is as quiet as you like it.</p>
                </div>
              ) : (
                <>
                  <div className="cart-items">
                    {items.map((item) => (
                      <div key={item.id} className="cart-item">
                        <img 
                          src={item.image} 
                          alt={item.name}
                          className="cart-item-image"
                        />
                        <div className="cart-item-details">
                          <h3 className="cart-item-name">{item.name}</h3>
                          <p className="cart-item-subtitle">{item.subtitle}</p>
                          <p className="cart-item-price">${item.price}</p>
                        </div>
                        <div className="cart-item-controls">
                          <button
                            className="quantity-btn"
                            onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                          >
                            <SafeIcon icon={FiMinus} />
                          </button>
                          <span className="quantity">{item.quantity}</span>
                          <button
                            className="quantity-btn"
                            onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                          >
                            <SafeIcon icon={FiPlus} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="cart-footer">
                    <div className="cart-total">
                      <span className="total-label">TOTAL</span>
                      <span className="total-price">${totalPrice}</span>
                    </div>
                    <button 
                      className="checkout-btn"
                      onClick={handleCheckout}
                    >
                      <SafeIcon icon={FiCreditCard} />
                      SECURE CHECKOUT
                    </button>
                  </div>
                </>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;